import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const SubscriptionCancel = () => {
  const navigate = useNavigate();

  const handleTryAgain = () => {
    navigate('/settings');
  };

  const handleGoBack = () => {
    navigate('/dashboard');
  };

  const primaryCtaClass =
    'font-secondary inline-flex w-full min-h-[48px] items-center justify-center whitespace-nowrap rounded-sm bg-primary px-6 py-3 text-[14px] font-semibold leading-tight text-black transition-colors hover:bg-primary-hover';

  const secondaryCtaClass =
    'font-secondary inline-flex w-full min-h-[48px] items-center justify-center whitespace-nowrap rounded-sm border border-white/15 bg-transparent px-6 py-3 text-[14px] font-semibold leading-tight text-white/80 transition-colors hover:bg-white/[0.06] hover:text-white';

  return (
    <div className="flex min-h-screen items-center justify-center bg-black px-6 py-12">
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35, ease: 'easeOut' }}
        className="w-full max-w-lg rounded-sm border border-white/10 bg-landing-section p-8 sm:p-10"
      >
        <div className="mb-8 flex justify-center">
          <motion.div
            initial={{ scale: 0.92, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.05, type: 'spring', stiffness: 260, damping: 22 }}
            className="flex h-16 w-16 items-center justify-center rounded-sm bg-white/5"
            aria-hidden
          >
            <svg
              className="h-9 w-9 text-white/70"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </motion.div>
        </div>

        <h1 className="font-title text-center text-2xl font-bold tracking-tight text-white sm:text-[28px]">
          Payment canceled
        </h1>
        <p className="font-secondary mt-6 text-center text-[15px] leading-relaxed text-gray-300">
          Your payment was not completed. No charges have been made to your account.
        </p>

        <div className="my-8 rounded-sm border border-white/10 bg-black/40 p-4">
          <p className="font-secondary text-center text-sm leading-relaxed text-gray-300">
            If you encountered any issues during checkout, contact support at{' '}
            <a
              href="mailto:nodes@nodefleet.net"
              className="font-semibold text-primary underline decoration-primary/40 underline-offset-2 transition-colors hover:text-primary-hover hover:decoration-primary-hover"
            >
              nodes@nodefleet.net
            </a>
            .
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <motion.button
            type="button"
            onClick={handleTryAgain}
            className={primaryCtaClass}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            Try again
          </motion.button>

          <motion.button
            type="button"
            onClick={handleGoBack}
            className={secondaryCtaClass}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            Back to Dashboard
          </motion.button>
        </div>

        <p className="font-secondary mt-6 text-center text-sm text-gray-400">
          You can subscribe later from Settings → Subscription.
        </p>
      </motion.div>
    </div>
  );
};

export default SubscriptionCancel;
